import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import PropTypes from "prop-types";
const PagePropsContext = createContext(void 0);
const PagePropsProvider = ({
  children,
  pageProps
}) => /* @__PURE__ */ jsx(PagePropsContext.Provider, { value: pageProps, children });
function usePageProps() {
  const context = useContext(PagePropsContext);
  if (context === void 0 && process.env.NODE_ENV === "development") {
    console.warn("usePageProps must be used within a PagePropsProvider");
  }
  return context;
}
PagePropsProvider.propTypes = {
  children: PropTypes.shape({}),
  pageProps: PropTypes.shape({})
};
export {
  PagePropsProvider,
  usePageProps
};
